import axios from "axios"
import { TransportService } from "../utils/web_config_2";

export async function unlockUser(userName){
    axios.defaults.baseURL = new TransportService().BASE_URL;
    let op = localStorage.getItem("nx_op") || localStorage.getItem("nx_cent")

    const outletInstance = axios.create(new TransportService());

    let user = JSON.stringify(op)

    await outletInstance.post('/api/v1/ticketing/unlock-account', {
        agent_user_name: userName
    },  
    {
        headers: {
            Authorization: "Bearer "+user.token
        }
    })
}

export async function unlockUserByAdminId(userName) {
    axios.defaults.baseURL = new TransportService().BASE_URL;
    let op = localStorage.getItem("nx_op") || localStorage.getItem("nx_cent")

    let user = JSON.stringify(op)

    const outletInstance = axios.create(new TransportService());

    await outletInstance.post('/api/v1/ticketing/unlock-account-by-admin-id', {
        agent_user_name: userName
    }, {
        headers: {
            Authorization: "Bearer "+user.token
        }
    })
}
